module.exports = __webpack_public_path__ + "static/media/company-logo.1617120a.png";